(() => {
  document.querySelectorAll('[data-proof]').forEach(root=>{
  const es=document.documentElement.lang.startsWith('es'),$=s=>root.querySelector(s),all=s=>[...root.querySelectorAll(s)];
  const t=(en,translated)=>es?translated:en;
  const copy={eyebrow:'PRUEBAS INDEPENDIENTES DE TERCEROS',thirdparty:'Pruebas de laboratorio independiente.',title:'Mejoras reales en la piel.<br><em>Medidas de forma independiente.</em>',intro:'Tu skincare diario, elevado.<br> Explora los cambios medidos de forma independiente en nuestras rutinas evaluadas.',mask:'MÁSCARA FACIAL LED',device:'DISPOSITIVO FACIAL',map:'28 DÍAS. CAMBIOS MEDIDOS.',red:'Luz roja',yellow:'Amarilla',blue:'Azul',scrollHint:'Desliza para seguir el cambio ↓',imageNote:'Retrato ilustrativo · no es una participante del estudio.',scope:'Cambios promedio en las rutinas evaluadas; las líneas se evalúan mediante puntuaciones por imagen. Los resultados varían. Sin comparación con cuidado tópico solo. Las líneas se evalúan mediante puntuaciones por imagen. Las cifras de GlowEdit corresponden a combinaciones de luz amarilla y azul.'};
  if(es)[...root.closest('.wl-proof').querySelectorAll('[data-i18n]')].forEach(el=>el.innerHTML=copy[el.dataset.i18n]);
  const yellow=t('Yellow-light combination','Combinación de luz amarilla'),blue=t('Blue-light combination','Combinación de luz azul');
  const boost=t('With tested serum','Con sérum evaluado');
  // Reported mean individual percentage changes, not ratios of rounded group means.
  // Sample sizes, conditions and source caveats remain in HANDOFF.md; no direct product comparison.
  const metrics={
    hydration:{label:t('Hydration','Hidratación'),measure:t('Skin moisture','Hidratación de la piel')},
    wrinkles:{label:t('Eye lines','Líneas de ojos'),measure:t('Crow’s-feet score','Puntuación de patas de gallo')},
    smile:{label:t('Smile lines','Surcos'),measure:t('Smile-line score','Puntuación de surcos nasolabiales')},
    blemishes:{label:t('Blemishes','Granitos'),measure:t('Blemish count','Número de granitos')},
    elasticity:{label:t('Elasticity','Elasticidad'),measure:t('Skin elasticity · R2','Elasticidad de la piel · R2')},
    radiance:{label:t('Radiance','Luminosidad'),measure:t('Skin gloss','Brillo de la piel')},
  };

  const records={
    glowedit:{
      hydration:{values:[0,16.1,38.1],mode:yellow,group:'yellow',source:'26NYFC-WT025, PDF p11, table 6'},
      wrinkles:{values:[0,-9.8,-26.8],mode:yellow,group:'yellow',source:'26NYFC-WT025, PDF p10, table 3'},
      smile:{values:[0,-10.4,-27.3],mode:yellow,group:'yellow',source:'26NYFC-WT025, PDF p10, table 4'},
      blemishes:{values:[0,-15.5,-25.0],mode:blue,group:'blue',source:'26NYFC-WT025, PDF p13, table 10'},
      
    },
    routinepair:{
      // Only D7 results common to CN and EN versions, pending confirmation of the final issued D28 report.
      hydration:{values:[0,17.7],visits:[0,7],mode:boost,source:'26NYFC-WT020, CN PDF p12 table8; EN PDF p15 table8'},
      elasticity:{values:[0,9.3],visits:[0,7],mode:boost,source:'26NYFC-WT020, CN PDF p12 table7; EN PDF p14 table7'},
      radiance:{values:[0,8.3],visits:[0,7],mode:boost,source:'26NYFC-WT020, CN PDF p11 table5; EN PDF p13 table5'}
    }
  };
  const product=root.dataset.device;
  $('.proof-chapter small').textContent=product==='glowedit'?t('01 / LED FACE MASK','01 / MÁSCARA FACIAL LED'):t('02 / SKINCARE DEVICE','02 / DISPOSITIVO FACIAL');
  let concern='hydration',point=records[product].hydration.values.length-1;
  const percent=n=>n===0?'0':(n>0?'+':'−')+Math.abs(n).toFixed(1);
  const iconPaths={hydration:'M12 3C10 7 5 11 5 15a7 7 0 0014 0c0-4-5-8-7-12Z',wrinkles:'M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12Z M15 12a3 3 0 11-6 0 3 3 0 016 0',smile:'M7 4C3 9 3 15 6 20 M17 4c4 5 4 11 1 16 M8 13q4 5 8 0',elasticity:'M5 9V5h4 M15 5h4v4 M19 15v4h-4 M9 19H5v-4 M8 12h8',radiance:'M12 3v3 M12 18v3 M3 12h3 M18 12h3 M6 6l2 2 M16 16l2 2 M6 18l2-2 M16 8l2-2 M16 12a4 4 0 11-8 0 4 4 0 018 0'};
  const icon=key=>`<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${iconPaths[key]}"/></svg>`;
  function select(key){concern=key;render();}
  function render(){
    const r=records[product][concern],m=metrics[concern],visits=r.visits||[0,7,28];
    const days=visits.map(day=>(es?'Día ':'Day ')+day);
    // Facial callouts always show the verified endpoint; the chart can explore earlier visits.

    root.dataset.device=product;
    $('.proof-image-label').textContent=product==='routinepair'?t('INDEPENDENTLY MEASURED.','MEDIDO DE FORMA INDEPENDIENTE.'):t(`${visits.at(-1)} DAYS. MEASURED CHANGE.`,`${visits.at(-1)} DÍAS. CAMBIOS MEDIDOS.`);
    const name=product==='glowedit'?'GlowEdit':'RoutinePair';
    $('[data-device-name]').textContent=name;
    if(product==='routinepair'&&!$('.proof-technologies')){
      const tech=document.createElement('p');tech.className='proof-technologies';
      tech.innerHTML='<span>RF <i>/</i> EMS <i>/</i> '+t('Ion ±','Iones ±')+'</span><span>'+t('TEC Warm + Cool','TEC Calor + Frío')+' <i>/</i> 88 LEDs</span>';
      $('.proof-scene-heading').append(tech);
    }
    $('[data-study]').hidden=product==='glowedit';
    $('[data-study]').textContent=t('Measured with tested serum','Medido con sérum evaluado');
    const cards=$('.proof-results');
    if(cards.dataset.product!==product){
      cards.replaceChildren();cards.dataset.product=product;
      const keys=product==='glowedit'?['hydration','wrinkles','smile']:['hydration','elasticity'];
      keys.forEach(key=>{
        const b=document.createElement('button');
        b.type='button';b.className='proof-callout proof-glass';b.dataset.concern=key;
        b.innerHTML=`<span class="proof-callout-label">${icon(key)}${metrics[key].label}</span><strong><span data-number>0</span><small>%</small></strong><span class="proof-callout-time"></span>`;
        b.onclick=()=>select(key);cards.append(b);
      });
    }
    if(product==='routinepair'&&!$('.proof-eye-feature')){
      const eye=document.createElement('div');eye.className='proof-eye-feature proof-glass';
      eye.innerHTML=icon('wrinkles')+`<span>${t('Eye lines','Líneas de ojos')}</span><strong>−30.4<small>%</small></strong><small>${t('Lifting test · immediate','Prueba Lifting · inmediato')}</small>`;
      eye.setAttribute('aria-label',t('Crow’s-feet image-analysis score: 30.4% lower immediately after Lifting with tested gel.','Puntuación por imagen de patas de gallo: 30,4% menor inmediatamente después de Lifting con el gel evaluado.'));
      // M4 English PDF p12 table3: immediate SLM Lifting result, not Eye Care mode or Day7.
      $('.proof-explorer').append(eye);
    }
    all('.proof-callout').forEach(card=>{
      const key=card.dataset.concern,data=records[product][key],value=data.values.at(-1);
      card.querySelector('.proof-callout-time').textContent=days.at(-1);
      card.setAttribute('aria-label',metrics[key].measure+', '+percent(value)+'%, '+days.at(-1));
      card.querySelector('[data-number]').textContent=percent(value);
    });
    all('[data-concern]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.concern===concern)));
    root.dataset.concern=concern;
    $('[data-blemishes]').hidden=product!=='glowedit';
    $('[data-blemishes]').innerHTML=t('Also measured: fewer blemishes <strong>−25.0%</strong><small>Blue-light combination · Day 28</small>','También medido: menos granitos <strong>−25.0%</strong><small>Combinación azul · Día 28</small>');
    $('[data-blemishes]').setAttribute('aria-pressed',String(concern==='blemishes'));
    $('[data-chart-label]').textContent=m.measure;
    $('[data-chart-unit]').textContent=t('% vs. Day 0','% frente al día 0');
    $('[data-active-day]').textContent=days[point];
    $('[data-active-change]').textContent=percent(r.values[point])+'%';
    $('[data-i18n="scope"]').textContent=t('Average changes in tested routines. Individual results vary. No skincare-only comparison.','Cambios promedio en las rutinas evaluadas. Los resultados varían. Sin comparación con cuidado tópico solo.')+(product==='glowedit'?t(' Line results are image-analysis scores. GlowEdit figures cover yellow- and blue-light combinations.',' Las líneas se evalúan mediante puntuaciones por imagen. Las cifras de GlowEdit corresponden a combinaciones de luz amarilla y azul.'):t(' Eye-line figure is an image-analysis score measured immediately after Lifting with tested gel; other figures are Day 7.',' La cifra de líneas de ojos es una puntuación por imagen medida inmediatamente después de Lifting con gel evaluado; las demás cifras corresponden al día 7.'));
    $('[data-pdp-label]').textContent=(es?'Conoce ':'Meet ')+name;
    $('[data-pdp]').href='https://wellogic.tech/'+(es?'':'en/')+'products/wellogic-'+(product==='glowedit'?'glowedit-led-face-mask':'routinepair-skincare-device');
    const timeline=$('.proof-timepoints');timeline.replaceChildren();
    days.forEach((label,i)=>{const b=document.createElement('button');b.type='button';b.textContent=label;b.dataset.point=i;b.setAttribute('aria-pressed',String(point===i));b.setAttribute('aria-label',`${label}: ${percent(r.values[i])}%`);b.onclick=()=>{point=i;render();$('.proof-timepoints').children[i].focus({preventScroll:true});};timeline.append(b);});
    const chart=$('.proof-chart svg'),width=Math.max(280,chart.clientWidth/Math.max(1,chart.clientHeight)*160),right=width-28;
    chart.setAttribute('viewBox',`0 0 ${width} 160`);
    $('.proof-grid').setAttribute('d',`M28 24H${right}M28 78H${right}M28 132H${right}`);
    const rising=r.values.at(-1)>0,positions=visits.map(day=>day/visits.at(-1)),scale=50;
    const coords=r.values.map((v,i)=>[28+positions[i]*(right-28),rising?132-Math.abs(v)/scale*108:24+Math.abs(v)/scale*108]);
    const path=coords.map((c,i)=>(i?'L':'M')+c.join(' ')).join(' '),base=rising?132:24;
    $('.proof-line').setAttribute('d',path);
    const activePath=coords.slice(0,point+1).map((c,i)=>(i?'L':'M')+c.join(' ')).join(' ');
    $('.proof-progress').setAttribute('d',activePath);
    $('.proof-area').style.fill=`url(#proof-fill-${product})`;
    $('.proof-area').setAttribute('d',`${activePath}L${coords[point][0]} ${base}L28 ${base}Z`);
    const cursor=$('.proof-cursor');['x1','x2'].forEach(a=>cursor.setAttribute(a,coords[point][0]));cursor.setAttribute('y1',24);cursor.setAttribute('y2',132);
    const dots=$('.proof-dots');dots.replaceChildren();
    coords.forEach(([x,y],i)=>{const circle=document.createElementNS('http://www.w3.org/2000/svg','circle');circle.setAttribute('cx',x);circle.setAttribute('cy',y);circle.setAttribute('r',point===i?7:4);if(point===i)circle.classList.add('selected');if(i>point)circle.classList.add('future');const label=document.createElementNS(circle.namespaceURI,'text');label.setAttribute('x',x);label.setAttribute('y',rising?y-13:y+23);label.textContent=percent(r.values[i])+'%';dots.append(circle,label);});
    requestAnimationFrame(drawConnectors);
    $('.proof-chart').setAttribute('aria-label',m.measure+': '+days.map((d,i)=>d+' '+percent(r.values[i])+'%').join('; '));
  }
  function drawConnectors(){
    const box=$('.proof-explorer').getBoundingClientRect(),photo=$('.proof-photo img').getBoundingClientRect(),svg=$('.proof-connectors');
    const spots={hydration:product==='glowedit'?[716,334]:[900,334],wrinkles:[923,270],smile:[859,382],elasticity:[711,334],radiance:[711,334]};
    svg.setAttribute('viewBox',`0 0 ${box.width} ${box.height}`);svg.replaceChildren();
    all('.proof-callout,.proof-eye-feature').forEach(card=>{
      const key=card.dataset.concern||'wrinkles',rect=card.getBoundingClientRect(),[px,py]=spots[key];
      const x=photo.left-box.left+px/1280*photo.width,y=photo.top-box.top+py/720*photo.height;
      const left=rect.left-box.left,right=rect.right-box.left,top=rect.top-box.top,bottom=rect.bottom-box.top;
      const cx=x<left?left:x>right?right:Math.max(left+12,Math.min(right-12,x));
      const cy=y<top?top:y>bottom?bottom:Math.max(top+12,Math.min(bottom-12,y));
      const group=document.createElementNS('http://www.w3.org/2000/svg','g');group.setAttribute('class',key===concern?'active':'');
      const line=document.createElementNS(group.namespaceURI,'path');line.setAttribute('d',`M${cx} ${cy} L${x} ${y}`);
      const dot=document.createElementNS(group.namespaceURI,'circle');dot.setAttribute('cx',x);dot.setAttribute('cy',y);dot.setAttribute('r',key===concern?3:2);
      group.append(line,dot);svg.append(group);
    });
  }
  $('[data-blemishes]').onclick=()=>select('blemishes');

  $('[data-next]').textContent=product==='glowedit'?t('Explore RoutinePair results →','Explora los resultados de RoutinePair →'):t('← Back to GlowEdit results','← Volver a los resultados de GlowEdit');
  $('[data-next]').dataset.switch=product==='glowedit'?'routinepair':'glowedit';
  $('[data-i18n="scrollHint"]').textContent=t('Measured over time','Medido a lo largo del tiempo');
  window.addEventListener('resize',()=>{if(!root.hidden)render();},{passive:true});
  root.addEventListener('proof-show',render);
  render();
  $('.proof-photo img').addEventListener('load',drawConnectors);
  });
  const section=document.querySelector('.wl-proof');
  const track=section.querySelector('.proof-scroll-track'),stage=section.querySelector('.proof-scroll-stage');
  const panels=[...section.querySelectorAll('[data-proof]')],tabs=section.querySelector('.proof-tabs');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const es=document.documentElement.lang.startsWith('es');
  let active='',pinned=false,travel=0,top=0,frame=0;
  function show(product){
    if(active===product)return;
    active=product;
    panels.forEach(panel=>{
      panel.hidden=pinned&&panel.dataset.device!==product;
      if(!panel.hidden)panel.dispatchEvent(new Event('proof-show'));
    });
    tabs.querySelectorAll('button').forEach(tab=>tab.setAttribute('aria-pressed',String(tab.dataset.switch===product)));
    section.querySelector('[data-journey-label]').textContent=(product==='glowedit'?'01 / GlowEdit':'02 / RoutinePair')+(es?' · Resultados medidos':' · Independently measured');
    section.querySelector('[data-journey-next]').textContent=product==='glowedit'?(es?'Sigue hacia RoutinePair ↓':'Scroll to RoutinePair ↓'):(es?'Sigue hacia tu ritual ↓':'Continue to your daily ritual ↓');
    stage.dataset.product=product;
  }
  function update(){
    frame=0;
    if(!pinned){
      show(panels[1].getBoundingClientRect().top<innerHeight*.5?'routinepair':'glowedit');
      return;
    }
    const progress=Math.max(0,Math.min(1,(top-track.getBoundingClientRect().top)/travel));
    show(progress<.5?'glowedit':'routinepair');
    stage.style.setProperty('--proof-progress',String(progress));
    // A restrained emphasis guides the eye; no measured values are interpolated.
    stage.dataset.reading=progress%0.5>.13?'detail':'overview';
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  function layout(){
    const previous=active||'glowedit';
    stage.style.minHeight='';
    top=document.querySelector('[data-wl-home]')?72:0;
    section.style.setProperty('--proof-top',top+'px');
    pinned=!reduced.matches;
    section.classList.toggle('proof-scroll',pinned);
    section.classList.remove('proof-flow');
    stage.style.setProperty('--proof-scene-height',Math.max(440,Math.min(730,innerHeight-top-168))+'px');
    // Measure both products, including translated footnotes, before pinning anything.
    let height=0;
    panels.forEach(panel=>{
      panels.forEach(p=>p.hidden=p!==panel);
      panel.dispatchEvent(new Event('proof-show'));
      height=Math.max(height,stage.getBoundingClientRect().height);
    });
    pinned=pinned&&height<=innerHeight-top-12;
    section.classList.toggle('proof-scroll',pinned);
    section.classList.toggle('proof-flow',!pinned);
    travel=innerHeight*1.8;
    track.style.height=pinned?(height+travel)+'px':'';
    stage.style.minHeight=pinned?height+'px':'';
    active='';show(previous);
    update();
  }
  section.querySelectorAll('[data-switch]').forEach(button=>button.addEventListener('click',()=>{
    const product=button.dataset.switch;
    if(pinned){
      const start=scrollY+track.getBoundingClientRect().top-top;
      // Jump to a stable reading interval; normal scrolling then resumes from there.
      window.scrollTo({top:start+(product==='routinepair'?travel*.57:travel*.06),behavior:'instant'});
      show(product);schedule();
    }else{
      show(product);
      panels.find(panel=>panel.dataset.device===product).scrollIntoView({block:'start',behavior:'instant'});
    }
  }));
  window.addEventListener('scroll',schedule,{passive:true});
  // Ignore mobile browser toolbar height changes; recompute for actual width/orientation changes.
  let width=innerWidth;
  window.addEventListener('resize',()=>{if(innerWidth!==width||innerWidth>680){width=innerWidth;layout();}},{passive:true});
  reduced.addEventListener('change',layout);
  layout();
  document.fonts.ready.then(layout);
})();
